import { TextField } from "@mui/material";
import FormButtons from '../Inputs/FormButtons';
import { useState } from "react";
import API from "../../services/API/Social";
import { useQueryClient, useMutation } from "react-query";
import Flex from '../Tools/Flex';
import { LoadingButton } from "@mui/lab";
import { useContext } from "react";
import UserContext from '../../services/Context/UserContext';
import { txt } from "../../services/translation";

export default function CommentForm({post, onClose, onSuccess, onError, queryKey, page, recipient}){

    const {user} = useContext(UserContext)

    const [submitting, setSubmitting] = useState(false);

    const [comment, setComment] = useState({
        content: '', 
        post: post,
        recipient: recipient
    })

    const [generating, setGenerating] = useState(false)

    const queryClient = useQueryClient();
    const commentsKey = 'comments' + post.id;

    const postComment = useMutation({
        mutationFn: () => API.postComment(comment).then(r => r.data),
        
        onMutate: () => null,

        onSuccess: newComment => {

            queryClient.setQueryData([commentsKey], old => {
                let copy = old ? [...old] : [];
                copy.push(newComment)
                return copy;
            })

            queryClient.setQueryData(queryKey, old => {
                const idx = old.pages[page - 1].data.findIndex(p => p.id === post.id);

                let newPost = {...post};
                newPost.commentsCount++;

                let copy = {...old};
                copy.pages[page - 1].data[idx] = newPost;

                return copy;
            })

            return onSuccess();
        },

        onError: () => onError(),

    })


    const handleSubmit = e => {
        e.preventDefault();
        postComment.mutateAsync();
        return setSubmitting(true);
    }

    const generate = () => {

        API.generateReply(post.id)
            .then(r => setComment({...comment, content: r.data?.content}))
            .catch(e => setComment({...comment, content: txt('errorOccurred')}))
            .finally(() => setGenerating(false))

        return setGenerating(true);
    }

    return <form onSubmit={handleSubmit}>

        <TextField 
            label={recipient ? txt('replyToRecipientLabel', { name: recipient.name }) : txt('myCommentLabel')}
            value={comment.content}
            onChange={e => setComment({
                ...comment, content: e.target.value    
            })}
            inputProps={{
                maxLength: 1000,
                minLength: 3
            }}
            required
            fullWidth
            sx={{mt: 4, mb: 1}}
            autoFocus
            variant="filled"
            multiline
            minRows={3}
        />

        <Flex justifyContent='space-between'>

            {user.admin ?
                <LoadingButton onClick={generate} loading={generating}>
                    Générer une réponse
                </LoadingButton> 
                :
                <div></div>
            }

            <FormButtons 
                onCancel={onClose}
                loading={submitting}
                submitText={txt('publish')}
            />

        </Flex>

    </form>
}